import { REVENUE_LEDGER_RUN_TIME_JST } from '@cortex/domain-ac-mens-hub-api';
import { useTranslation } from 'react-i18next';

/**
 * @graph-node {Module}
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business 当月の値をまだ出さない月（前日を基準日とする計算がまだ無い月）を、月次・前受金・チャート・版の比較の上に同じ文言で注記する。空の列を未実行や売上0と取り違えないため。該当月が無ければ何も出さない。
 * @graph-connects none
 */
export function PendingMonthsNote({
  months,
  className = '',
}: {
  months: readonly string[];
  className?: string;
}) {
  const { t } = useTranslation();
  if (months.length === 0) return null;
  return (
    <p role="status" className={`text-xs text-[var(--color-text-secondary)] ${className}`}>
      {t('revenue.ledger.pendingMonths', {
        months: months.join('・'),
        time: REVENUE_LEDGER_RUN_TIME_JST,
      })}
    </p>
  );
}
